import { asyncReducer } from 'redux-promise-middleware-actions';
import { searchWebinars } from './actions';

const searchWebinarReducer = asyncReducer(searchWebinars);

export default (state = {}, action) => searchWebinarReducer(state, action);
